import { useTranslation } from '@mc/i18n'

import { RelatedContentCarousel } from './RelatedContentCarousel'
import { useRelatedContent } from './useRelatedContent'

export const RelatedContent = () => {
  const { t } = useTranslation('@mc/next')
  const relatedContent = useRelatedContent()

  return (
    <div className='container mc-mb-8'>
      <h2 className='mc-text-h2 mc-mb-4 mc-pl-1'>
        {t('episode.relatedContent.title')}
      </h2>
      <div className='d-none d-md-block'>
        <RelatedContentCarousel
          content={relatedContent}
          scrollCount={3}
          showCount={3}
          aspectRatio='16x9'
        />
      </div>

      <div className='d-none d-sm-block d-md-none'>
        <RelatedContentCarousel
          content={relatedContent}
          scrollCount={2}
          showCount={2}
          aspectRatio='16x9'
        />
      </div>

      <div className='d-block d-sm-none'>
        <RelatedContentCarousel
          content={relatedContent}
          scrollCount={1}
          showCount={1}
          aspectRatio='1x1'
        />
      </div>
    </div>
  )
}
